import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import "../Profile/Profile.css";
import PhotoProfile from "./Components/PhotoProfile";
import EditDataUser from "./Components/EditDataUser";

class AccountSettings extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div className="text-center mt-1 pt-5 mb-5">
          <PhotoProfile />
          <EditDataUser />
        </div>
      </React.Fragment>
    );
  }
}

export default AccountSettings;
